export * from './data-helper.service';
export * from './backend.service';
export * from './insurance.service';
export * from './form.reducer';
export * from './store';

export * from './pax-form-control/index';
export * from './pax-form-control/pax-form-control.component';
export * from './pax-form-control/pax-form-control.service';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/index.ts